import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { history } from 'routes/history';
import { store } from './store/configureStore';
import { setInitialTitleDocument } from 'utilities/initialization';
import { getRoutes } from './routes/';
import { pushOptimize } from 'utilities/optimize';

require('text-security/dist/text-security-disc.css');

const subscribeAll = () => {
    store.subscribe(() => pushOptimize());
};

async function enableMocking() {
    if (process.env.NODE_ENV !== 'development' || !__ALLOW_MSW__) {
        return;
    }

    const { worker } = await import('./mocks/browser');

    return worker.start({
        onUnhandledRequest: 'bypass',
    });
}

setInitialTitleDocument();
subscribeAll();

enableMocking().then(() => {
    ReactDOM.render(
        <Provider store={store}>
            <Router history={history}>{getRoutes()}</Router>
        </Provider>,
        document.getElementById('app')
    );
});
